import { useState } from "react";
import { useEditor } from "./useEditor";
import { useMessage } from "./useMessage";

export const useSelectedProductAttribute = () => {
	const editor = useEditor();
	const [selectedProductAttribute, setSelectedProductAttribute] = useState(
		editor.definition?.selectedAttributeCode,
	);

	useMessage((message) => {
		if (eXpress.core.isAttributeChanged(message)) {
			setSelectedProductAttribute(editor.definition?.selectedAttributeCode);
		}
	});

	return selectedProductAttribute;
};
